import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import messages from '../../../../assets/locale/messages';
import { ViewBgIcon } from '../../../../utils/Icons';
import { getEmployeeDetailsRequest } from '../../../../store/Employees/actions';
import EmptyState from '../../../../components/EmptyState';
import Tooltip from '../../../../components/Tooltip'
import { timeConverter } from '../../../../utils/Helpers';
import { renderFormatedDate } from '../../../../utils/DateHelpers';
import { weekDays, weekDaysAr, employeeStatusList} from '../../../../utils/Constants';
import './ViewEmployeesDetails.scss';
import { ROUTE_PATHS } from '../../../../utils/RoutesPaths';

const ViewEmployeesDetails = ({ btnClicked, changeSubTitle, renderList }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { branches, shared, serviceProviders, employees } = messages[lang];
  const history = useHistory();
  const { id } = useParams();
  const dispatch = useDispatch();
  const branchData = useSelector((state) => state.branches.branchDetails);
  const employeeDetails = useSelector((state) => state.employees.employeeDetails);

  const [showBranchEmployeesList, setShowBranchEmployeesList] = useState(true);
  const [showBranchEmployeeDetails, setShowBranchEmployeeDetails] = useState(false);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);


  useEffect(() => {
    if (selectedEmployeeId) {
      dispatch(getEmployeeDetailsRequest({ id: selectedEmployeeId }));
    }
  }, [selectedEmployeeId]);

  useEffect(() => {
    if (employeeDetails) {
      let selectedEmployeeMappedData = {};
      selectedEmployeeMappedData = { ...employeeDetails };
      let workingDays = [
        {
          id: 0,
          label: shared.days.sat,
          value: weekDays.sat,
          isChosen: false,
          timeSlots: [],
        },
        {
          id: 1,
          label: shared.days.sun,
          value: weekDays.sun,
          isChosen: false,
          timeSlots: [],
        },
        {
          id: 2,
          label: shared.days.mon,
          value: weekDays.mon,
          isChosen: false,
          timeSlots: [],
        },
        {
          id: 3,
          label: shared.days.tus,
          value: weekDays.tus,
          isChosen: false,
          timeSlots: [],
        },
        {
          id: 4,
          label: shared.days.wed,
          value: weekDays.wed,
          isChosen: false,
          timeSlots: [],
        },
        {
          id: 5,
          label: shared.days.thurs,
          value: weekDays.thurs,
          isChosen: false,
          timeSlots: [],
        },
        {
          id: 6,
          label: shared.days.fri,
          value: weekDays.fri,
          isChosen: false,
          timeSlots: [],
        },
      ];
      selectedEmployeeMappedData.employee_working_hours?.forEach((workingDay) => {
        const dayIndex = workingDays.findIndex((day) => day.value.toLowerCase() === workingDay.week_day);
        if (dayIndex !== -1) {
          workingDays[dayIndex].isChosen = true;
          workingDays[dayIndex].timeSlots = workingDay.intervals.map((interval) => {
            return {
              startTime: interval.starts_at,
              endTime: interval.ends_at,
            };
          });
        }
      });
      selectedEmployeeMappedData.workingDays = workingDays;
      setSelectedEmployee(selectedEmployeeMappedData);
    }
  }, [employeeDetails]);

  useEffect(() => {
    if (renderList) {
      setShowBranchEmployeesList(true);
      setShowBranchEmployeeDetails(false);
    }
  }, [renderList]);

  const renderStatusCase = (employee) => {
    if (employee.status === employeeStatusList.suspended && employee.deactivation_date) {
      return (
        <Tooltip
          title={`${employees.list.suspendedByDeactivateEmployee} ${renderFormatedDate(
            employee.deactivation_date
          )}`}
          content={<span>{RenderTitle(employee.status)}</span>}
          hasArrow
        />
      );
    } else {
      return <span>{RenderTitle(employee.status)}</span>;
    }
  };

  const RenderTitle = (title) => {
    switch (title) {
      case employeesStatus.active:
        return `${employees.list.statusCases.active}`;
      case employeesStatus.deactivated:
        return `${employees.list.statusCases.deactivated}`;
      case employeesStatus.suspended:
        return `${employees.list.statusCases.suspended}`;
      case employeesStatus.blocked:
        return `${employees.list.statusCases.blocked}`;
      default:
        return `-`;
    }
  };

  const employeesStatus = useMemo(
    () => ({
      active: 'active',
      deactivated: 'deactivated',
      suspended: 'deactivation_scheduled',
      blocked:'blocked'
    }),
    []
  );

  const renderBranchEmployeesList = () => {
    return (
      <>
        <div className="view-employees-list">
          <div className="bg-white rounded-4 p-4">
            {branchData?.employees?.length > 0 ? (
              <>
                <div>
                  {branchData?.employees?.length > 0 && (
                    <div className="d-flex align-items-center justify-content-between p-2 px-4 mb-4">
                      <div className="flex-grow-1 d-flex flex-column flex-md-row align-items-md-center align-items-start gap-2 text-gray">
                        <div className="fsize-16 fweight-600 flex-basis-34">
                          {branches.addBranch.specialtiesAndServices.employeeName}
                        </div>
                        <div className="fsize-16 fweight-600">{branches.addBranch.labels.phone}</div>
                      </div>
                    </div>
                  )}
                  {branchData?.employees.map((employee) => {
                    return (
                      <div
                        className="employee d-flex justify-content-between align-items-center px-4 py-2 text-primary fweight-600"
                        key={employee.id}>
                        <div className="flex-grow-1 d-flex flex-column flex-md-row align-items-md-center align-items-start gap-2">
                          <div className="flex-basis-40">
                            {lang === 'en'
                              ? employee.first_name_en + ' ' + employee.last_name_en
                              : employee.first_name_ar + ' ' + employee.last_name_ar}
                          </div>
                          <div>{employee.phone_number}</div>
                        </div>
                        <div className="d-flex gap-2 align-items-center">
                          <div className={`${employee.status}-container py-1 px-3 rounded-4 d-flex gap-1`}>
                            {renderStatusCase(employee)}
                          </div>
                          <div
                            className="small-icon-bg  pointer"
                            onClick={() => {
                              history.push(ROUTE_PATHS.viewEmployee.replace(':id', employee.id));
                            }}>
                            <ViewBgIcon />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            ) : (
              <div className={` ${!branchData?.employees?.length > 0 && 'mx-auto w-50'}`}>
                <EmptyState
                  subTitle={shared.noEmployeesAdded}
                  showActionButton={false}
                  NoDataListWithNoActionBtn={true}
                />
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  const renderDayLabel = (day) => {
    switch (day.id) {
      case 0:
        return lang === 'en' ? weekDays.sat : weekDaysAr.sat;
      case 1:
        return lang === 'en' ? weekDays.sun : weekDaysAr.sun;
      case 2:
        return lang === 'en' ? weekDays.mon : weekDaysAr.mon;
      case 3:
        return lang === 'en' ? weekDays.tus : weekDaysAr.tus;
      case 4:
        return lang === 'en' ? weekDays.wed : weekDaysAr.wed;
      case 5:
        return lang === 'en' ? weekDays.thurs : weekDaysAr.thurs;
      case 6:
        return lang === 'en' ? weekDays.fri : weekDaysAr.fri;

      default:
        return '-';
    }
  };

  

  const renderBranchEmployeeDetails = () => {
    return selectedEmployee ? (
      <div className="employeeDetails">
        <div>
          {/* name and phone number */}
          <div className="bg-white rounded-4 p-4">
            <div className="mb-4">
              <div className="text-dark font-medium mb-2">{branches.addBranch.specialtiesAndServices.employeeName}</div>
              <div className="text-gray font-medium">
                {selectedEmployee?.first_name + ' ' + selectedEmployee?.last_name}
              </div>
            </div>
            <div className="mb-2">
              <div className="text-dark font-medium mb-2">{branches.addBranch.labels.phone}</div>
              <div className="text-gray font-medium">{selectedEmployee?.phone_number || ''}</div>
            </div>
          </div>
          {/* working hours */}
          <div className="bg-white rounded-4 p-4 mt-4">
            <div className="text-dark font-medium mb-2">{branches.addBranch.labels.workingHours}</div>
            <div className="days text-gray">
              {selectedEmployee?.workingDays?.map((day) => {
                return (
                  <div
                    className="d-flex gap-3 align-items-md-center align-items-start flex-column flex-md-row mb-3"
                    key={day.id}>
                    <div className="day flex-basis-15 text-secondary fsize-18">
                      {lang === 'en' ? renderDayLabel(day) : renderDayLabel(day)}
                    </div>
                    {day.isChosen ? (
                      <>
                        {day.timeSlots.map((slot, i) => {
                          return (
                            <div className="slot-one bg-section p-2 px-3" key={i}>
                              {branches.addBranch.specialtiesAndServices.from} : {timeConverter(slot.startTime, lang)} -
                              {branches.addBranch.specialtiesAndServices.to} : {timeConverter(slot.endTime, lang)}
                            </div>
                          );
                        })}
                      </>
                    ) : (
                      <div className="text-red font-medium">{shared.closed}</div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          {/* location */}
          <div className="bg-white rounded-4 p-4 mt-4">
            <div className="text-dark font-medium mb-2">{branches.addBranch.specialtiesAndServices.location}</div>
            <div className="text-gray">
              <div>
                {(selectedEmployee.offered_location === 'home' || selectedEmployee.offered_location === 'both') && (
                  <div className="fweight-600 fsize-16"> {branches.addBranch.placeholders.atHome}</div>
                )}
              </div>
              {selectedEmployee.offered_location === 'both' && <div className="divider my-3"></div>}
              <div>
                {(selectedEmployee.offered_location === 'in_place' || selectedEmployee.offered_location === 'both') && (
                  <div className="fweight-600 fsize-16">{branches.addBranch.placeholders.atBranch} </div>
                )}
              </div>
            </div>
          </div>
          {/* services */}
          <div className="bg-white rounded-4 p-4 mt-4">
            <div className="text-dark font-medium mb-2">{branches.addBranch.specialtiesAndServices.assignServices}</div>
            <div>
              {selectedEmployee?.services?.length > 0 ? (
                <div>
                  {selectedEmployee?.services?.map((service, i) => {
                    return (
                      <div key={service.id} className="px-3 py-2  bg-section mb-3 font-medium text-dark fsize-16">
                        {lang === 'en' ? service.title_en : service.title_ar}
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="text-red fweight-600 fsize-16">{shared.noServicesAddedyet}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    ) : (
      <></>
    );
  };
  return (
    <>
      {showBranchEmployeesList && renderBranchEmployeesList()}
      {showBranchEmployeeDetails && renderBranchEmployeeDetails()}
    </>
  );
};

export default ViewEmployeesDetails;
